import styled from "styled-components";

export const Styled = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  .avatar {
    padding: 0;
    width: 24px;
    height: 24px;
  }

  .info {
    display: flex;
    flex-direction: column;
    font-style: normal;

    .name {
      margin: 0;
      font-weight: 400;
      overflow: hidden;
      text-overflow: ellipsis;
      color: var(--color-gray-950, #19191b);
      font-size: var(--font-size-md, 16px);
      line-height: var(--font-line-height-md, 24px);
    }

    .email {
      color: var(--Grey-70, var(--Grey-70, #757576));
      font-size: var(--font-size-xs, 12px);
      line-height: var(--font-line-height-xs, 16px);
    }
  }
`;
